import React from 'react'
import { translate } from 'react-i18next'
import './index.sass'

const PrivacyPolicy = ({ t }) => <div className='privacy-policy' dangerouslySetInnerHTML={{ __html: t('privacyPolicy') }} />

export default translate('translations')(PrivacyPolicy)
